module.exports = __webpack_public_path__ + "assets/discount_flower-02bb95.svg";